import axios from 'axios';
import type { identifier } from '@core/models/base';
import type { AccessCodeSearchDisplayModel } from '@shared/models/subjects/accessCode';
import { JobDisplayModelV3 } from '@shared/models/jobs/v3/displayModels';
import { JobAvailabilityDisplayModel } from '../models/job';

/**
 * Search by accesscode, wholegallerypasscode or subject password
 * @param studioId
 * @param code
 */
export const getJobsByCode = async (studioId: identifier, code: string) =>
  (await axios.get<AccessCodeSearchDisplayModel[]>(`/api/customer/studios/${studioId}/jobs/${code}`)).data;

export const fetchJobDetails = async (jobId: identifier) =>
  (await axios.get<JobDisplayModelV3>(`/api/customer/jobs/${jobId}`)).data;

export const getJobAvailability = async (jobId: identifier) => {
  return (await axios.get<JobAvailabilityDisplayModel>(`/api/customer/jobs/${jobId}/availability`)).data;
};

export const fetchUniqueJobsByCode = async (studioId: identifier, code: string) => {
  const jobs = await getJobsByCode(studioId, code);

  if (!jobs || !jobs.length) {
    return [];
  }

  return jobs;
};
